import { createApp } from "vue";
import App from "./App.vue";
import i18n from './i18n'
import router from "./router.js";
import '@fortawesome/fontawesome-free/css/all.css'

import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import VueApexCharts from 'vue3-apexcharts'

import './assets/tailwind.css'


// import "primevue/resources/themes/lara-light-blue/theme.css"; 

// import "primevue/resources/primevue.min.css"; 
// import "primeicons/primeicons.css"; 
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";





const app = createApp(App);

if (import.meta.env.DEV) {
  app.config.devtools = true
}
app.use(Toast, {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
});
app.component('apexchart', VueApexCharts)


app.use(router);
app.use(PrimeVue);
app.use(ToastService);
app.use(i18n);

app.mount("#app");